if (!customElements.get('cart-complete-set-upsell')) {
  class CartCompleteSetUpsell extends HTMLElement {
    connectedCallback() {
      const variantsScript = this.querySelector('[data-complete-set-variants]');
      this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

      this.variantInput = this.querySelector('[data-complete-set-variant-id]');
      this.priceEl = this.querySelector('[data-complete-set-price]');
      this.submitBtn = this.querySelector('[data-complete-set-submit]');
      this.submitText = this.querySelector('[data-complete-set-submit-text]');
      this.sizeGroup = this.querySelector('[data-complete-set-size-group]');
      this.sizeButton = this.querySelector('[data-complete-set-size-toggle]');
      this.sizeList = this.querySelector('[data-complete-set-size-list]');
      this.sizeLabel = this.querySelector('[data-complete-set-size-label]');

      if (!this.variantInput || !this.sizeGroup || !this.sizeButton || !this.sizeList) return;

      this.onDocClick = (event) => {
        if (!this.contains(event.target)) this.closeList();
      };
      document.addEventListener('click', this.onDocClick);
      this.sizeButton.addEventListener('click', () => this.toggleList());
      this.sizeList.addEventListener('click', (event) => {
        const option = event.target.closest('[data-complete-set-size]');
        if (!option || option.disabled || option.dataset.available === 'false') return;
        this.selectOption(option);
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeList();
      });
      this.syncFromSize();
    }

    disconnectedCallback() {
      if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
    }

    toggleList() {
      if (this.sizeList.hasAttribute('hidden')) {
        this.sizeList.removeAttribute('hidden');
        this.sizeButton.setAttribute('aria-expanded', 'true');
      } else {
        this.closeList();
      }
    }

    closeList() {
      if (!this.sizeList) return;
      this.sizeList.setAttribute('hidden', '');
      this.sizeButton.setAttribute('aria-expanded', 'false');
    }

    selectOption(option) {
      this.sizeGroup.querySelectorAll('[data-complete-set-size]').forEach((item) => {
        const selected = item === option;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      this.closeList();
      this.syncFromSize();
    }

    syncFromSize() {
      const current = this.sizeGroup.querySelector('[data-complete-set-size][aria-selected="true"]');
      if (!current) return;

      const variantId = current.dataset.variantId;
      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      const available = variant.available;
      this.variantInput.value = variant.id;
      this.variantInput.disabled = !available;

      if (this.sizeLabel) {
        this.sizeLabel.textContent = current.textContent.replace(/\s+/g, ' ').trim();
      }

      if (this.priceEl && typeof formatMoney === 'function') {
        this.priceEl.textContent = formatMoney(
          variant.price,
          window.theme?.moneyFormat
        );
      }

      if (this.submitBtn) {
        this.submitBtn.disabled = !available;
        if (this.submitText) {
          this.submitText.textContent = available
            ? this.submitText.dataset.defaultLabel || this.submitText.textContent
            : (window.variantStrings?.soldOut || 'Sold out');
        }
      }
    }
  }

  customElements.define('cart-complete-set-upsell', CartCompleteSetUpsell);
}
